export default __webpack_public_path__ + "static/space-3-1f10449e81c17bfa882081158e0448af.jpg";